// BL-177 Step 2k: the browser's one door to the reservation-from-conversation Edge Function (signed-in staff only; the
// function re-checks access). Resolves with the function's body; rejects with a plain Error whose message is safe to show.
import { readFunctionError } from './staffReply';

export const RESERVATION_FUNCTION = 'reservation-from-conversation';

export async function callReservation(client, payload) {
    const { data, error } = await client.functions.invoke(RESERVATION_FUNCTION, { body: payload });
    if (error) {
        const parsed = await readFunctionError(error);
        throw new Error(parsed.message === 'The reply could not be sent.' ? 'The reservation could not be created.' : parsed.message);
    }
    if (data?.error) throw new Error(typeof data.error === 'string' ? data.error : 'The reservation could not be created.');
    if (!data || data.ok === false) throw new Error('The reservation could not be created.');
    return data;
}

export const startReservation = (client, sessionId) => callReservation(client, { action: 'start', sessionId, reviewOnly:true });
export const approveReservation = (client, reservationId, fields) => callReservation(client, { action: 'approve', reservationId, fields });
export const timeoutReservation = (client, reservationId) => callReservation(client, { action: 'timeout', reservationId });
export const cancelReservation = (client, reservationId) => callReservation(client, { action: 'cancel', reservationId });
export const loadReservationForTrip = (client, engagementId) => callReservation(client, { action: 'load', engagementId });
